// @flow

import React, { Component } from 'react';
import DebounceInput from 'react-debounce-input';
import styler from 'react-styling';
import { FormGroup } from 'react-bootstrap/lib';

const style = styler `
    Search
      padding-left: 12px
  `;

class TextFilter extends Component {
  props: {
    searchPlaceholder: string,
    searchHandleTextIput: Function,
    debounce: number,
    value: string,
    id: string,
  };

  searchContacts: HTMLInputElement

  _searchClear = () => {
    this.searchContacts.value = '';
    this.props.searchHandleTextIput();
  }

  render() {
    return (
      <FormGroup>
        <DebounceInput
          placeholder={this.props.searchPlaceholder}
          className="Select-control"
          minLength={1}
          value={this.props.value}
          debounceTimeout={this.props.debounce}
          onChange={this.props.searchHandleTextIput}
          style={style.Search}
          id={this.props.id}
        />

        {/* <Button
          onClick={this._searchClear}
          bsStyle="link"
          className="search-clear"
        >
          <i className="fa fa-close" />
        </Button>*/}
      </FormGroup>
    );
  }
}

export default TextFilter;



// WEBPACK FOOTER //
// ./src/js/Components/TextFilter.js